import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	SignaturesOfPetition,
	type SignaturesOfPetitionQuery,
	type SignaturesOfPetitionQueryVariables,
} from './useFetchSignatures.graphql';

export const fetchSignatures = async ({
	petitionId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	petitionId: string;
	utilityContext: UtilityContext;
}) => {
	try {
		const { data } = await fetch<SignaturesOfPetitionQuery, SignaturesOfPetitionQueryVariables>({
			query: SignaturesOfPetition,
			variables: {
				petitionId,
			},
			rejectOnError: true,
			important: true,
		});

		if (
			!data ||
			!data.getSignaturesOfPetition ||
			!data.getSignaturesOfPetition.items ||
			data.getSignaturesOfPetition.items.length === 0
		) {
			throw new Error();
		}

		const { items: signaturesWithPosition } = data.getSignaturesOfPetition;

		return { distribution: signaturesWithPosition };
	} catch {
		return null;
	}
};
